var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.correct.length
    ? _c(
        "div",
        { staticClass: "enkronos-credits-usage" },
        [
          _c("h4", [
            _vm._v(
              "\n    " +
                _vm._s(_vm._f("trans")("billings:credits_usage.title")) +
                "\n    "
            ),
            _c("abbr", {
              directives: [
                {
                  name: "help",
                  rawName: "v-help",
                  value: [
                    "<b>" +
                      _vm.$t("billings:credits_usage.title") +
                      "</b><br/>",
                    "billings:credits_usage.help",
                    "billings:credits_usage.usage"
                  ],
                  expression:
                    "[\n      '<b>' + $t('billings:credits_usage.title') + '</b><br/>',\n      'billings:credits_usage.help',\n      'billings:credits_usage.usage',\n    ]"
                }
              ],
              staticClass: "btn"
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid" }, [
            _c("div", [
              _c("h4", [
                _vm._v(_vm._s(_vm._f("trans")("billings:credits_usage.all")))
              ]),
              _vm._v(" "),
              Number(_vm.current.credits) === 0
                ? _c("ins", [_vm._v("∞")])
                : _c("ins", [
                    _vm._v(_vm._s(_vm._f("number")(_vm.current.credits, 3)))
                  ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("h4", [
                _vm._v(_vm._s(_vm._f("trans")("billings:credits_usage.used")))
              ]),
              _vm._v(" "),
              _c(
                "ins",
                { class: _vm.spent ? "state-error" : "state-success" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("number")(
                          _vm.correct.log_apptokens_resource_credits_used,
                          3
                        )
                      ) +
                      "\n      "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.spent
            ? [
                _c("br"),
                _vm._v(" "),
                _c("p", { staticClass: "spent" }, [
                  _vm._v(
                    _vm._s(_vm._f("trans")("billings:credits_usage.spent"))
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn lg",
                    attrs: { to: { name: "billings.new" } }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm._f("trans")("billings:plans.switch")) +
                        "\n    "
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b783721", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b783721","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/billings/components/CreditsUsage.vue
// module id = null
// module chunks = 